import { API_BASE_URL } from '../config';

export const getReportsList = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/reports`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching reports list:', error);
    throw error;
  }
};

export const getChatReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/chat-reports?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching chat reports:', error);
    throw error;
  }
};

export const getChatAnalytics = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams({ ...params, type: 'analytics' });
    const response = await fetch(`${API_BASE_URL}/api/chat-reports?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching chat analytics:', error);
    throw error;
  }
};

export const getMissedChats = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/chat-reports/missed?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching missed chats:', error);
    throw error;
  }
};

export const getRequisitionsReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/requisitions?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching requisitions reports:', error);
    throw error;
  }
};

export const getPendingRequisitionsReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/pending_requisitions?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching pending requisitions reports:', error);
    throw error;
  }
};

export const getRFQReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/rfq?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching RFQ reports:', error);
    throw error;
  }
};

export const getChatsReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams({ ...params, type: 'detailed' });
    const response = await fetch(`${API_BASE_URL}/api/chat-reports?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching chats reports:', error);
    throw error;
  }
};

// Alias for backward compatibility
export const getRfqReports = getRFQReports;

export const getUserActivityReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/user?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching user activity reports:', error);
    throw error;
  }
};

export const getChangesReports = async (params = {}) => {
  try {
    // Rewire to use enterprise logging system
    const queryParams = new URLSearchParams();
    
    // Map old parameters to enterprise logging parameters
    if (params.changeType) queryParams.append('search', params.changeType);
    if (params.module) queryParams.append('search', params.module);
    if (params.user) queryParams.append('user_id', params.user);
    if (params.severity) queryParams.append('level', params.severity);
    if (params.status) queryParams.append('search', params.status);
    if (params.dateRange?.start) queryParams.append('date_from', params.dateRange.start);
    if (params.dateRange?.end) queryParams.append('date_to', params.dateRange.end);
    
    // Add enterprise logging specific filters for critical changes
    queryParams.append('channel', 'audit'); // Focus on audit trail changes
    queryParams.append('level', 'critical,error,warning'); // Focus on critical changes
    queryParams.append('limit', params.limit || '100');
    queryParams.append('page', params.page || '1');
    
    const response = await fetch(`${API_BASE_URL}/api/enterprise-logs/?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Transform enterprise logging data to match expected format
    if (data.status === 1 && data.data) {
      const transformedData = data.data.map(log => ({
        id: log.id,
        change_id: log.id,
        change_type: log.context?.operation || log.context?.action || 'system_change',
        type: log.context?.operation || log.context?.action || 'system_change',
        severity: log.level,
        impact_level: log.level,
        module: log.context?.module || log.context?.entity_type || 'System',
        affected_module: log.context?.module || log.context?.entity_type || 'System',
        user: log.user_name,
        user_name: log.user_name,
        changed_by: log.user_name,
        status: log.context?.status || 'completed',
        created_at: log.timestamp,
        change_date: log.timestamp,
        timestamp: log.timestamp,
        description: log.message,
        change_description: log.message,
        details: log.message,
        context: log.context
      }));
      
      return {
        status: 1,
        data: {
          changes: transformedData,
          total: data.meta?.total || transformedData.length,
          page: data.meta?.current_page || 1,
          per_page: data.meta?.per_page || 100
        }
      };
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching changes reports from enterprise logs:', error);
    throw error;
  }
};

export const getHelpdeskReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/helpdesk?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching helpdesk reports:', error);
    throw error;
  }
};

export const getProcurementReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/procurement?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching procurement reports:', error);
    throw error;
  }
};

export const getAutomatedActivityReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/automated_activity?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching automated activity reports:', error);
    throw error;
  }
};

export const getMailLogReports = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/mail_log?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching mail log reports:', error);
    throw error;
  }
};

export const exportReport = async (type, params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const response = await fetch(`${API_BASE_URL}/api/reports/export/${type}?${queryParams}`, {
      method: 'GET',
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type}_report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting report:', error);
    throw error;
  }
};

export const printReport = async (type, params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const url = `${API_BASE_URL}/api/reports/print/${type}?${queryParams}`;
    window.open(url, '_blank');
  } catch (error) {
    console.error('Error printing report:', error);
    throw error;
  }
};
